'use client';

import { useCallback } from 'react';

/**
 * From AI:
 * ## Rule of thumb
 * Use:
 * - __`sessionStorage`__ for short-lived flow state, redirects, one-time handoff data
 * - __`localStorage`__ for durable client preferences or drafts you intentionally want to survive longer
 */
export const useSessionStorage = () => {
	const setSessionStorageItem = useCallback( ( key: string, value: string ) => {
		if ( typeof window === 'undefined' ) {
			return;
		}

		window.sessionStorage.setItem( key, value );
	}, [] );

	const getSessionStorageItem = useCallback( ( key: string ) => {
		if ( typeof window === 'undefined' ) {
			return null;
		}

		return window.sessionStorage.getItem( key );
	}, [] );

	const removeSessionStorageItem = useCallback( ( key: string ) => {
		if ( typeof window === 'undefined' ) {
			return;
		}

		window.sessionStorage.removeItem( key );
	}, [] );

	return {
		setSessionStorageItem,
		getSessionStorageItem,
		removeSessionStorageItem,
	};
};
